import React from "react";

const Blog = () => {
  return (
    <div className="blog-section">
      <div className="container">
        <div className="text-section">
          <h3>Hire us whenever</h3>
          <p>
            The buses can be hired not only for tourism, but also for leisure
            activities like picnics, field trips, excursions, and formal
            requirements like corporate events, meetings, weddings, and more.
          </p>
          <p>
            No matter whether you want to hire/rent a vehicle for a whole day or
            just a few hours, we will meet your needs. Bus for hire is now one
            click away. We also ensure extra comfort, luxurious and hassle-free
            experience, and of course, a punctual and expert service
          </p>
        </div>
        <div className="text-section">
          <h3>Hiring/Renting A Bus with Ryde</h3>
          <p>
            Ryde understands that comfort and enjoyment are important while
            travelling. Therefore, we have collaborated with some of the finest
            travel agencies in Nepal and Bangladesh to render a perfect trip to our customers.
            The passengers can opt for air conditioned or non-air conditioned
            buses. The buses also have push back and recliner seats making it
            possible for the elderly to travel. Buses are also equipped with LCD
            TV and DVD player for your entertainment. Buses may also come
            equipped with mini-refrigerators and ice boxes for refreshment.
            Facilities like comfy blankets, and charging ports are also
            available in buses.
          </p>
          <p>
            You can also book a sleeper coach bus with Ryde. For long-distance
            night travel, travelling in a sleeper bus is the best option.
            Sleeper bus booking is possible online with Ryde.
          </p>
        </div>
        <div className="text-section">
          <h3>Benefits of Ryde</h3>
          <p>
            With the roomy interiors in our buses, you get enough space to relax
            so that you do not get feel suffocated. It is relatively
            cost-effective to rent a bus from Ryde All the buses we onboard are
            verified. Ryde checks the quality of each vehicle onboard before
            sending them to customers. Drivers have an app which allows high quality
            tracking. Our support centers are open 24/7 and 365 days
            a year.
          </p>
          <p>
            MyJourney.ltd works closely with the best bus service providers in the
            country. All you need to do is to answer a few simple questions
            about your trip. Once you fill up the form, you get detailed
            quotations from some of the best bus operators of your city of
            travel.
          </p>
        </div>
        <div className="text-section">
          <h3>Things to know about Ryde</h3>
          <p>
            Ryde is amongst the list of renowned online bus booking websites. It
            has earned its place among the best due to its ability to cater to
            every customer’s specific travel needs while also providing them
            with nothing but the best travel experience. In doing so, they
            provide their customers with a plethora of bus booking options. It
            works with only the best operators and ensures that only the most
            experienced drivers drive buses. Ryde makes booking an ordinary
            vehicle, such as a tempo traveller or minibus, for a group vacation
            much more comfortable and more accessible. Ryde offers customers
            with air-conditioned as well as non-air-conditioned buses to choose
            from and book. It also provides sleeper buses that operate at night.
            Ryde and Ryde bus rental can be done either through the use of the
            official website or the easy to download MyJourney.ltd application.
          </p>
          <p>
            Ryde has been making sure to take care of all its customer’s health
            and also play a role in curbing the further spread of COVID-19. In a
            bid to do just this, Ryde has come out with an initiative called
            Safety+ under which there are specific preventive guidelines all
            buses must adhere .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blog;
